/* Café 1715 — méga-menu plein écran : drill-down (avant/retour) façon La Marzocco. */
(function () {
  function showPanel(mega, key) {
    mega.querySelectorAll('[data-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== key;
    });
  }

  document.addEventListener('click', function (e) {
    var drill = e.target.closest('[data-cafe-drill]');
    if (drill) {
      e.preventDefault();
      e.stopPropagation();
      showPanel(drill.closest('[data-cafe-mega]'), drill.getAttribute('data-cafe-drill'));
      return;
    }
    var back = e.target.closest('[data-cafe-back]');
    if (back) {
      e.preventDefault();
      e.stopPropagation();
      showPanel(back.closest('[data-cafe-mega]'), 'root');
    }
  });

  // Revenir à l'écran racine UNIQUEMENT quand on quitte le sous-menu entier
  // (pointerleave ne bouillonne pas : en capture, on filtre sur la cible = le panneau).
  document.addEventListener('pointerleave', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('menu-list__submenu')) return;
    var mega = t.querySelector('[data-cafe-mega]');
    if (mega) showPanel(mega, 'root');
  }, true);
})();
